<template>
  <v-list class="chatChannels" subheader two-line>
    <v-list-item v-show="channels.length === 0">
      <v-list-item-content class="grey--text text-body-1" style="align-items: center">
        <vs-text type="caption" class="text-center">
          No results
          <template v-if="noSearchText">
            for <i>{{ store.searchText }}</i>
          </template>
          <br />
          Make sure to check your filters.
        </vs-text>
      </v-list-item-content>
    </v-list-item>

    <v-virtual-scroll :items="channels" height="450" item-height="64" bench="10">
      <template #default="{ item }">
        <slot :item="item">
          <ChannelInfo :key="item.documentId" :channel="item" @channel-clicked="channelClicked" />
          <v-divider />
        </slot>
      </template>
    </v-virtual-scroll>
  </v-list>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Channel } from '../common/chat/models'
import { useChatStore } from '../common/chat/useChatData'
import ChannelInfo from './ChannelInfo.vue'

withDefaults(
  defineProps<{
    channels: Channel[]
  }>(),
  { channels: () => [] },
)

const emits = defineEmits<{
  (event: 'channel-clicked', channel: any)
}>()

const store = useChatStore()

const noSearchText = computed(() => {
  return store.searchText && store.searchText !== ''
})

const channelClicked = ({ documentId, group, unsubscribed }) => {
  emits('channel-clicked', { documentId, group, unsubscribed })
}
</script>

<style>
.chatChannels.list--two-line .list__tile {
  height: 56px;
}
</style>
